import { createReader } from "./utils/reader.js";
export function* streamMessage(buf, codec, opts) {
    const reader = createReader(buf);
    yield* codec.stream(reader, undefined, '$', opts);
}
//# sourceMappingURL=stream.js.map